import React from 'react';
import { Box } from '@mui/material';

type Props = {
    topBar?: React.ReactNode;
    content: React.ReactNode;
    bottomBar?: React.ReactNode;
    contentMinHeight?: number;
    contentHeightOffset?: {
        xs?: string;
        sm?: string;
        md?: string;
        lg?: string;
    };
    disableContentCard?: boolean;
};

export default function ResponsiveWorkspaceLayout({
    topBar,
    content,
    bottomBar,
    contentMinHeight = 320,
    contentHeightOffset = {
        xs: '220px',
        sm: '240px',
        md: '250px',
        lg: '260px',
    },
    disableContentCard = false,
}: Props) {
    return (
        <Box
            sx={{
                minHeight: 0,
                display: 'grid',
                gridTemplateRows: 'auto 1fr auto',
                gap: { xs: 1, md: 1, lg: 1.5 },
            }}
        >
            {topBar ? <Box>{topBar}</Box> : null}

            <Box
                sx={{
                    border: disableContentCard ? 'none' : '1px solid',
                    borderColor: disableContentCard ? 'transparent' : 'divider',
                    borderRadius: disableContentCard ? 0 : 2,
                    overflow: 'auto',
                    bgcolor: disableContentCard ? 'transparent' : 'background.paper',
                    height: {
                        xs: `calc(100dvh - ${contentHeightOffset.xs || '220px'})`,
                        sm: `calc(100dvh - ${contentHeightOffset.sm || '240px'})`,
                        md: `calc(100dvh - ${contentHeightOffset.md || '250px'})`,
                        lg: `calc(100dvh - ${contentHeightOffset.lg || '260px'})`,
                    },
                    minHeight: contentMinHeight,
                }}
            >
                {content}
            </Box>

            {bottomBar ? <Box>{bottomBar}</Box> : null}
        </Box>
    );
}